/* ShopBebidas — cross-sell do cart drawer (desconto progressivo 3+ = 5% · 6+ = 10%).
   O pool é renderizado server-side em cart-drawer.liquid e re-renderiza a cada
   adição via Section Rendering (o texto "faltam N garrafas" atualiza sozinho).
   Roda FORA do #CartDrawer (que é substituído via innerHTML), então usa
   event delegation. */
(function () {
  'use strict';
  if (window.__sbCupd) return;
  window.__sbCupd = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sb-cupd-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    if (!id) return;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: '/' })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        /* fallback: sem sections na resposta, busca a seção à parte */
        if (!data.sections || !data.sections['cart-drawer']) {
          return fetch('/cart?section_id=cart-drawer')
            .then(function (r) { return r.text(); })
            .then(function (t) {
              var doc = new DOMParser().parseFromString(t, 'text/html');
              var novo = doc.querySelector('#CartDrawer');
              var atual = document.querySelector('#CartDrawer');
              if (novo && atual) {
                atual.innerHTML = novo.innerHTML;
                var ov = document.getElementById('CartDrawer-Overlay');
                if (ov && drawer) ov.addEventListener('click', drawer.close.bind(drawer));
              }
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb-cupd' });
              }
              if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
            });
        }
        if (data.sections && data.sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          var novo = doc.querySelector('#CartDrawer');
          var atual = document.querySelector('#CartDrawer');
          if (novo && atual) {
            atual.innerHTML = novo.innerHTML;
            /* o replace de innerHTML derruba o listener do overlay — religa */
            var ov = document.getElementById('CartDrawer-Overlay');
            if (ov && drawer) ov.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        if (data.sections && data.sections['cart-icon-bubble']) {
          var bolha = document.getElementById('cart-icon-bubble');
          if (bolha) {
            var docB = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var novoB = docB.querySelector('.shopify-section') || docB.body;
            bolha.innerHTML = novoB.innerHTML;
          }
        }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb-cupd' });
        }
        if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .catch(function () {})
      .finally(function () { btn.disabled = false; });
  });
})();
